module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1228.fed0b4fe.png";